// For more font: https://gist.github.com/sadikay/d5457c52e7fb2347077f5b0fe5ba9300

const FONTS = {
  Roboto: "http://fonts.gstatic.com/s/roboto/v16/zN7GBFwfMP4uA6AR0HCoLQ.ttf",
  "Open Sans":
    "http://fonts.gstatic.com/s/opensans/v13/cJZKeOuBrn4kERxqtaUH3aCWcynf_cDxXwCLxiixG1c.ttf",
  Raleway: "http://fonts.gstatic.com/s/raleway/v11/bIcY3_3JNqUVRAQQRNVteQ.ttf",
  Quicksand:
    "http://fonts.gstatic.com/s/quicksand/v6/sKd0EMYPAh5PYCRKSryvW6CWcynf_cDxXwCLxiixG1c.ttf",
  Oswald: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
  Overlock:
    "http://fonts.gstatic.com/s/overlock/v5/oIwdBjO99oH_APMcy7EuWPesZW2xOQ-xsNqO47m55DA.ttf",
  Coda: "http://fonts.gstatic.com/s/coda/v11/KzHY9N-PIagGI86CpWfnZA.ttf",
  Comfortaa:
    "http://fonts.gstatic.com/s/comfortaa/v9/qLBu5CQmSMt1H43OiWJ77aCWcynf_cDxXwCLxiixG1c.ttf",
};

export const FONT_NAMES = Object.keys(FONTS);

export default FONTS;
